export default (node) => {
	var copy = node.querySelector('.js-copy');
	var to_copy = node.querySelector('.js-to-copy');
	var tooltip = node.querySelector('.js-tooltip');

	if (!copy) { copy = node};
	to_copy = (!to_copy) ? document.location : to_copy.innerText;

	copy.addEventListener('click', () => {
		navigator.clipboard.writeText(to_copy);

		tooltip.classList.add('active');

		setTimeout(() => {
			tooltip.classList.remove('active');
		}, 1500);	

	})
};